module.exports = __webpack_public_path__ + "static/media/Supplement Ingredient.a37a4496.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cont/Supplement Ingredient.png
// module id = 1191
// module chunks = 0